// actions.js
import {
  FETCH_RELEASES_REQUEST,
  FETCH_RELEASES_SUCCESS,
  FETCH_RELEASES_FAILURE,
  OPEN_EDIT_RELEASE_PAGE,
  OPEN_EDIT_RELEASE_PAGE_SUCCESS,
  DELETE_RELEASES_REQUEST,
  DELETE_RELEASES_FAILURE,
  DELETE_RELEASES_SUCCESS,
  FETCH_RELEASE_REQUEST,
  FETCH_RELEASE_SUCCESS,
  FETCH_RELEASE_FAILURE,
  UPDATE_RELEASES_REQUEST,
  UPDATE_RELEASES_SUCCESS,
  UPDATE_RELEASES_FAILURE,
  CLEAR_RELEASE_ERRORS,
  CLEAR_RELEASE_SUCCESS
} from './actionTypes';

export const fetchReleasesRequest = () => ({
  type: FETCH_RELEASES_REQUEST,
});

export const fetchReleasesSuccess = (releases) => ({
  type: FETCH_RELEASES_SUCCESS,
  payload: releases,
});

export const fetchReleasesFailure = (error) => ({
  type: FETCH_RELEASES_FAILURE,
  payload: error,
});

export const fetchReleaseRequest = (id) => ({
  type: FETCH_RELEASE_REQUEST,
  payload: id
});

export const fetchReleaseSuccess = (release) => ({
  type: FETCH_RELEASE_SUCCESS,
  payload: release,
});

export const fetchReleaseFailure = (error) => ({
  type: FETCH_RELEASE_FAILURE,
  payload: error,
});

export const updateReleaseRequest = (release, navigate) => ({
  type: UPDATE_RELEASES_REQUEST,
  payload: { release, navigate }
});

export const updateReleaseSuccess = () => ({
  type: UPDATE_RELEASES_SUCCESS,
});

export const updateReleaseFailure = (error) => ({
  type: UPDATE_RELEASES_FAILURE,
  payload: error,
});

export const deleteReleaseRequest = (id) => ({
  type: DELETE_RELEASES_REQUEST,
  payload: id
});

export const deleteReleaseSuccess = (id) => ({
  type: DELETE_RELEASES_SUCCESS,
  payload: id,
});

export const deleteReleaseFailure = (error) => ({
  type: DELETE_RELEASES_FAILURE,
  payload: error,
});

export const openEditReleasePage = (id, navigate) => ({
  type: OPEN_EDIT_RELEASE_PAGE,
  payload: { id, navigate }
});

export const openEditReleasePageSuccess = () => ({
  type: OPEN_EDIT_RELEASE_PAGE_SUCCESS,
});

export const clearReleaseErrors = () => ({
  type: CLEAR_RELEASE_ERRORS,
});

export const clearReleaseSuccess = () => ({
  type: CLEAR_RELEASE_SUCCESS,
});